import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { LockOutlined, Save } from "@mui/icons-material";
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword,
  signOut,
} from "firebase/auth";
import { auth } from "../firebase";
import { toast } from "react-toastify";

const Settings = () => {
  const [oldpassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [copassword, setCoPassword] = useState("");

  const navigate = useNavigate();

  const logout = async () => {
    await signOut(auth);
    navigate("/");
  };

  const handleUpdate = async () => {
    if (!oldpassword) return toast("Current password cannot be empty", { type: "warning" });
    if (!password) return toast("New password cannot be empty", { type: "error" });
    if (password !== copassword) return toast("Passwords don't match", { type: "error" });

    try {
      const user = auth.currentUser;
      const credential = EmailAuthProvider.credential(user.email, oldpassword);
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, password);

      setOldPassword("");
      setPassword("");
      setCoPassword("");

      toast("Password updated. Signing you out...", { type: "success" });
      setTimeout(logout, 3000);
    } catch (error) {
      if (error.code === "auth/wrong-password" || error.code === "auth/invalid-credential") {
        toast("Current password is incorrect", { type: "warning" });
      } else {
        toast("Error updating password", { type: "error" });
        console.error(error);
      }
    }
  };

  const inputClass = "w-full px-4 py-3 border border-gray-200 rounded-xl font-abel text-sm text-gray-700 focus:outline-none focus:border-[#000C66] focus:ring-2 focus:ring-[#000C66]/10 transition";
  const labelClass = "block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 font-abel";

  return (
    <Fragment>
      <div className="min-h-screen bg-[#f5f7fe] p-3 sm:p-6">
        <div className="max-w-2xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-xl bg-[#eef2ff] flex items-center justify-center flex-shrink-0">
              <LockOutlined style={{ color: "#000C66", fontSize: 20 }} />
            </div>
            <div>
              <h1 className="text-xl sm:text-2xl font-bold text-[#000C66] font-aref">Settings</h1>
              <p className="text-gray-400 text-xs font-abel">Update your account password</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-8">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <label className={labelClass}>Current Password *</label>
                <input
                  type="password"
                  value={oldpassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  placeholder="••••••••"
                  className={inputClass}
                />
              </Grid>

              <Grid item xs={12}>
                <div className="border-t border-gray-100 pt-4">
                  <p className="text-xs text-gray-400 font-abel mb-4 uppercase tracking-wider font-semibold">New Password</p>
                </div>
              </Grid>

              <Grid item xs={12} sm={6}>
                <label className={labelClass}>New Password *</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className={inputClass}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <label className={labelClass}>Confirm New Password *</label>
                <input
                  type="password"
                  value={copassword}
                  onChange={(e) => setCoPassword(e.target.value)}
                  placeholder="••••••••"
                  className={inputClass}
                />
              </Grid>

              <Grid item xs={12} className="flex justify-end">
                <button
                  onClick={handleUpdate}
                  className="w-full sm:w-auto flex items-center justify-center gap-2 bg-[#000C66] text-white px-8 py-3 rounded-xl font-abel font-semibold hover:bg-blue-900 transition"
                >
                  <Save style={{ fontSize: 18 }} />
                  Update Password
                </button>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Settings;
